let pick_data1 = [
    {
        id : 72,
        imgurl : '/img/section7/section7_all1.jpg',
        brand : 'COLUMBIA UNIVERSITY',
        title : 'VASITY ATH.DEPT.LOGO T',
        persent : '31%',
        price : '49,000',
        saleprice : '33,520',
    },
    {
        id : 73,
        imgurl : '/img/section7/section7_all2.jpg',
        brand : 'FITFLOP',
        title : '레더 밝은 브라운 여성 쪼리 샌들',
        persent : '26%',
        price : '169,000',
        saleprice : '124,720',
    },
    {
        id : 74,
        imgurl : '/img/section7/section7_all3.jpg',
        brand : 'JILLSTUART NEW YORK ACC',
        title : '베이지 트래블 보스턴백 L',
        persent : '34%',
        price : '328,000',
        saleprice : '234,360',
    },
    {
        id : 75,
        imgurl : '/img/section7/section7_all4.jpg',
        brand : 'WEDGWOOD',
        title : '르네상스그레이 5피스 세트',
        persent : '34%',
        price : '360,000',
        saleprice : '234,360',
    },
    {
        id : 76,
        imgurl : '/img/section7/section7_all5.jpg',
        brand : 'DAKS MEN',
        title : 'DRY TOUCH 닥스훈트 로고핑크 티셔츠',
        persent : '31%',
        price : '159,000',
        saleprice : '108,760',
    },
    {
        id : 77,
        imgurl : '/img/section7/section7_all6.jpg',
        brand : 'HYERES LOR',
        title : '노아이유 실버 담수진주 비드 목걸이',
        persent : '16%',
        price : '348,000',
        saleprice : '291,280',
    },
    {
        id : 78,
        imgurl : '/img/section7/section7_all7.jpg',
        brand : 'FITFLOP',
        title : '레더 블랙 남성 쪼리 샌들',
        persent : '28%',
        price : '169,000',
        saleprice : '121,680',
    },
    {
        id : 79,
        imgurl : '/img/section7/section7_all8.jpg',
        brand : 'HAZZYS GOLF',
        title : '블랙 트리컬러 보스턴백',
        persent : '19%',
        price : '218,000',
        saleprice : '176,580',
    }
]

export default pick_data1